import { IconButton, styled, Tooltip } from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ForumIcon from "@mui/icons-material/Forum"; // ✅ replaced FeedbackIcon
import { useNavigate } from "react-router-dom";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, isRtl }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: "black",
    color: "white",
    fontSize: isRtl ? 15 : 12,
  },
}));

const CategoryViewChild = () => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const [loading, setLoading] = useState(false); // State to control loader visibility
  const navigate = useNavigate();
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCategoryView = () => {
    setLoading(true); // Show loader
    setTimeout(() => {
      setLoading(false); // Hide loader before navigating
      navigate("/ForumsCategory");
    }); // Adjust the delay as needed

    handleMenuClose();
  };

  return (
    <div>
      <CustomTooltip
        title={t("Forum")}
        placement={i18n.dir() === "rtl" ? "left" : "right"}
      >
        <IconButton sx={{ color: "white" }} onClick={handleCategoryView}>
          <ForumIcon fontSize="medium" />
        </IconButton>
      </CustomTooltip>
    </div>
  );
};

export default CategoryViewChild;
